export const DropdownFilter = (elementSelector) => {
  const dropdown = document.querySelector(elementSelector);
  if(!dropdown) return false;
  const select = dropdown.querySelector('.js-dropdown-filter-select');
  const close = dropdown.querySelector('.js-dropdown-close');

  close.addEventListener('click', function(e) {
    e.preventDefault();
    dropdown.classList.remove('show');
  }, false);

  select.addEventListener('click', function(e) {
    e.preventDefault();
    dropdown.classList.toggle('show');
  }, false);

  document.addEventListener('click', function(e) {
    let match = false;
    for (let target = e.target; target && target != this; target = target.parentNode) {
      if (target.matches(elementSelector)) {
        match = true;
        break;
      }
    }

    if(!match) dropdown.classList.remove('show')
  }, false)
}
